import { Skeleton } from '@app/components/various/Skeleton';
import { cn } from '@app/utils/cn';
import { PropsWithChildren } from 'react';

interface Props {
  isLoading?: boolean;
  className?: string;
  multiline?: boolean;
}

export const ReadOnlyField = ({ multiline = false, isLoading = false, children, className }: PropsWithChildren<Props>) => {
  if (isLoading) {
    return <Skeleton type="input" size="large" />;
  }

  return (
    <div
      className={cn(
        'min-h-10 rounded-regular bg-neutral-96 px-3 py-2.5 body-2',
        {
          'max-h-24 overflow-y-scroll whitespace-pre-wrap break-words': multiline,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
